import React from 'react';
import { createRoom } from '../firestore/room';
import { CurrentUserContext } from '../contexts/CurrentUserContext';
import { useHistory, Redirect } from 'react-router';

// TODO: Don't allow unless logged in
export const Lobby = () => {
    const { currentUserId } = React.useContext(CurrentUserContext);
    const [roomToJoin, setRoomToJoin] = React.useState('');

    const history = useHistory();

    if (!currentUserId) {
        return <Redirect to="/login" />;
    }

    return (
        <div>
            <button
                onClick={() =>
                    createRoom().then(({ id: roomId }) => {
                        history.push(`/room/${roomId}`);
                    })
                }
            >
                Create Room
            </button>
            <input value={roomToJoin} onChange={(e) => setRoomToJoin(e.target.value)} />
            <button
                onClick={() => {
                    history.push(`/room/${roomToJoin}`);
                }}
            >
                Join Room
            </button>
        </div>
    );
};
